module.exports = {
    TEXT:               'text',
    BOLD:               'BOLD',
    ITALIC:             'ITALIC',
    CODE:               'CODE',
    STRIKETHROUGH:      'STRIKETHROUGH',
    HTML:               'HTML'
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/constants/styles.js
// module id = 75
// module chunks = 0